import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { generateBaseEntity } from '../utils/generate-base-entity'

export function createRecaptcha(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
  type?: EntityTypeEnum.OptInRecaptcha | EntityTypeEnum.ContactUsRecaptcha,
): RecaptchaInterface {
  const recaptcha: RecaptchaInterface = {
    ...generateBaseEntity(
      type || EntityTypeEnum.OptInRecaptcha,
      parentId,
      masterBlockId,
    ),
    parentId,
    slug: FieldSlugEnum.Recaptcha,
    theme: 'light',
    alignSelf: 'flex-start',
  }

  return recaptcha
}
